import { TFunction } from 'i18next';

import { Constants } from '@/lib/supabase';
import { StatusIndicatorType } from '@/shared/components/status-indicator';
import { InvitationStatus } from '@/shared/types/api';

export const invitationStatusOptions = Constants.public.Enums.invitation_status;

export const getInvitationStatusText = ({
  status,
  t,
}: {
  status: InvitationStatus | null | undefined;
  t: TFunction<'shared', 'InvitationStatus'>;
}) => {
  switch (status) {
    case 'pending':
      return t('invited');
    case 'accepted':
      return t('active');
    case 'declined':
      return t('rejected');
    case 'cancelled':
      return t('cancelled');
    case null:
    case undefined:
      return '';
  }
};

export const getInvitationStatusType = ({
  status,
}: {
  status: InvitationStatus | null | undefined;
}) => {
  switch (status) {
    case 'pending':
      return StatusIndicatorType.WARNING;
    case 'accepted':
      return StatusIndicatorType.POSITIVE;
    case 'declined':
    case 'cancelled':
      return StatusIndicatorType.NEGATIVE;
    case null:
    case undefined:
      return StatusIndicatorType.POSITIVE;
  }
};
